var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import styles from './cookie-category-description-list.component.scss';
import { Component, h } from 'preact';
import TranslateService from '../../service/translate.service';
var CookieCategoryDescriptionList = /** @class */ (function (_super) {
    __extends(CookieCategoryDescriptionList, _super);
    function CookieCategoryDescriptionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookieCategoryDescriptionList.prototype.render = function (props) {
        return (h("div", { id: "cookieCategoryDescriptionList", class: props.visible ? styles['cookie-category-description-list'] + " " + styles['visible'] : "" + styles['cookie-category-description-list'] }, props.categories.map(function (category) { return (h("div", { class: "" + styles['cookie-category-description'] },
            h("div", null,
                h("b", null, category.languages[TranslateService.getLanguage()].name)),
            h("div", null, category.languages[TranslateService.getLanguage()].description))); })));
    };
    return CookieCategoryDescriptionList;
}(Component));
export default CookieCategoryDescriptionList;



//////////////////
// WEBPACK FOOTER
// ./components/cookie-category-description-list/cookie-category-description-list.component.tsx
// module id = null
// module chunks = 